import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-be0d3934"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "bg-white w-6 h-6 md:w-10 md:h-10 rounded-full flex items-center content-start pl-1 md:pl-2 gap-1 overflow-hidden text-secondary hover:w-20 focus:w-20 md:hover:w-28 md:focus:w-28 focus:outline-none close-btn" }
const _hoisted_2 = { class: "label text-sm md:text-lg" }

import { useI18n } from "vue-i18n";
import Icon from "./Icon.vue";


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const { t } = useI18n();

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("button", _hoisted_1, [
    _createVNode(Icon, {
      name: "close",
      size: "s"
    }),
    _createElementVNode("span", _hoisted_2, _toDisplayString(_unref(t)("home.back")), 1)
  ]))
}
}

})